import { Box, styled, Typography } from '@mui/material';

export const BoldTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.h2.fontSize,
  fontWeight: theme.typography.fontWeightMediumBold,
  marginBottom: theme.spacing(2),
  padding: 0,
}));

export const CandidatesListContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

export const CandidateRequestorInfoContainer = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  padding: theme.spacing(3),
  paddingRight: 0,
  width: '37.5%',
  marginTop: 0.5,
  [theme.breakpoints.down('md')]: {
    marginRight: 0,
    padding: theme.spacing(2),
    width: '100%',
  },
}));

export const CandidateRow = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.gray.darker}`,
  borderRadius: theme.shape.borderRadius * 2,
  display: 'flex',
  marginBottom: theme.spacing(3),
  minHeight: theme.spacing(12.5),
  backgroundColor: 'white',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const Container = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.white.darker,
  height: '100%',
  padding: theme.spacing(4),
}));

export const CTAButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const Date = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.tertiary,
  paddingLeft: theme.spacing(1),
  [theme.breakpoints.down('lg')]: {
    paddingLeft: 0,
  },
}));

export const DateAndName = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
  display: 'flex',
  justifyContent: 'start',
  paddingTop: theme.spacing(1),
  [theme.breakpoints.down('lg')]: {
    alignItems: 'start',
    flexDirection: 'column',
    justifyContent: 'start',
    marginTop: 0,
  },
}));

export const Detail = styled(Typography)(({ theme }) => ({
  color: theme.palette.black.dark,
  fontWeight: theme.typography.fontWeightMedium,
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.dark,
  fontSize: theme.typography.print.fontSize,
}));

export const Form = styled('form')({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
});

export const FormContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: 'white',
  borderRadius: theme.shape.borderRadius * 2,
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(3),
  width: '1000px',
}));

export const HeaderContainer = styled(Box)({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '37px',
});

export const HelpText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.tertiary,
  fontSize: theme.typography.body2.fontSize,
  marginTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(2),
}));

export const JobInfoContainer = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  padding: `${theme.spacing(3)} ${theme.spacing(3)}`,
  width: '35%',
  [theme.breakpoints.down('md')]: {
    marginRight: 0,
    padding: `0 ${theme.spacing(2)}`,
    width: '100%',
  },
}));

export const Key = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMediumBold,
}));

export const LandingFormContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(3),
}));

export const ModalCloseButtonContainer = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'end',
});

export const ModalContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  borderRadius: theme.shape.borderRadius * 3,
  color: theme.palette.black.darker,
}));

export const Notes = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  marginLeft: theme.spacing(2),
}));

export const OptionTitle = styled(Box)({
  width: '50%',
});

export const Right = styled(Box)({
  display: 'flex',
  justifyContent: 'end',
});

export const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(0.25),
}));

export const Status = styled(Box)({
  alignItems: 'center',
  display: 'flex',
});

export const StatusAndNotes = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  marginTop: theme.spacing(1),
}));

export const SubContainer = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(3),
}));

export const SuccessSubContainer = styled(SubContainer)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.black.dark,
  fontWeight: theme.typography.fontWeightMedium,
}));
